import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'
import PostInsightsContent from 'modules/posts/components/PostInsightsContent'

type Props = {
  postId: string
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

const PostInsightsModal = ({ postId, isOpen, onOpenChange }: Props) => {
  const handleClose = () => onOpenChange(false)

  return (
    <F0Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title={i18n.t('posts.communities.insights.breadcrumb')}
      width="lg"
    >
      <PostInsightsContent postId={postId} />
    </F0Dialog>
  )
}

export default PostInsightsModal
